export const useStickyContact = () => {
    const { data: story } = useConfig();

    const stickyContactConfig: ComputedRef<StickyContactFormStoryblok | null> = computed(() => {
        if (!story.value?.content?.stickyContactConfig?.length) return null;

        return story.value.content.stickyContactConfig[0] as StickyContactFormStoryblok;
    });

    const uuid = computed(() => story.value?.uuid ?? null);

    return {
        stickyContactConfig,
        uuid
    };
};
